import React from 'react';
import { CircularProgress } from '@mui/material';

/**
 * An icon that turns into a spinner while its action runs — for a button,
 * menu item or icon button that starts a download, so the loader shows
 * exactly where the person clicked.
 */
const BusyIcon: React.FC<{ busy: boolean; children: React.ReactElement; size?: number }> = ({ busy, children, size = 16 }) =>
  busy ? <CircularProgress size={size} thickness={5} color="inherit" /> : children;

export default BusyIcon;
